<template>
    <div class="senders">
        <div v-for="(sender, index) in senders" class="sender" :key="index">
            <div class="logo_holder">
                <img :src="'images/senders/' + sender.sender_name + '.png'" />
            </div>
            <div>
                <div class="sender_name">{{ sender.alias }}</div>
                <div class="info">{{ t('settings-plugins-sender') }}: {{ sender.sender_name }}</div>
                <div class="info">
                    {{ t('settings-plugins-monthly_value') }}: R${{ sender.sender_price }}
                </div>
                <div class="info">
                    {{ t('settings-plugins-cost_per_message') }}: {{ sender.credits_cost }} {{ t('settings-plugins-credits') }}
                </div>
                <button
                    @click="$emit('edit', sender)"
                    class="btn btn-outline-success btn-small"
                >
                    {{ t('edit') }}
                </button>
            </div>
        </div>
        <div v-if="senders.length === 0">
            <p>{{ t('settings-plugins-none_registered') }}</p>
        </div>
    </div>
</template>
<style scoped lang="scss">
.senders {
    display: flex;
    flex-direction: column;
    gap: 20px;
    .sender {
        display: flex;
        gap: 20px;
        .logo_holder {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-basis: 25%;
            aspect-ratio: 1/1;
            border: 1px solid #888;

            img {
                max-height: 100%;
                max-width: 100%;
            }
            .img {
                background: #aaa;
                width: 100%;
                height: 100%;
            }
        }
        .sender_name {
            font-weight: 600;
            font-size: 16px;
        }
    }
}
</style>
<script>
export default {
    props: {
        senders: {
            type: Array,
            required: true,
        },
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
};
</script>
